import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';

class UsageStatsListService {
  fetch = new FetchService();
  companiesFetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      schools: [],
      companies: [],
      allCompanies: [],
    });
    this.form.validations = {
      month: [isRequired],
    };
  }

  init = action(() => {
    this.companies = [];
    this.companiesFetch.fetch({
      url: '/companies',
      query: {
        page: 1,
        size: 1000
      }
    }).then(() => {
      if (this.companiesFetch.data) {
        this.allCompanies = this.companiesFetch.data.docs;
      } else {
        this.allCompanies = [];
      }
    })
  });

  load = action((type, params) => {

    this.fetch.fetch({
      url: `/reports/${type}/usage-stats`,
      query: {
        ...params,
        ...params.month && {
          month: params.month.format('MM-YYYY')
        },
        ...params.from && {
          from: params.from.format('YYYY-MM-DD')
        },
        ...params.to && {
          to: params.to.format('YYYY-MM-DD')
        },
      },
    }).then(() => {
      if (this.fetch.data) {
        this.companies = this.fetch.data;
        
        this.companies = [
          ...this.fetch.data,
          ...this.allCompanies.filter(c => !this.fetch.data.some(x => x.id === c.id) && (!params.company || c.id === params.company) && (!params.distributor || c.distributor === params.distributor))
        ];
      } else {
        this.schools = [];
      }
    });
  });
}

const usageStatsListService = new UsageStatsListService();

export default usageStatsListService;
